/**
 * Puma
 * @category    ScandiPWA
 * @author      Ricards Nedosvitnijs <info@scandiweb.com>
 * @copyright   Copyright (c) 2021 Scandiweb, Ltd (https://scandiweb.com)
 */

import ProductListQuery from 'Query/ProductList.query';
import { updateNoMatch } from 'Store/NoMatch/NoMatch.action';
import { updateProductDetails } from 'Store/Product/Product.action';
import { QueryDispatcher } from 'Util/Request';

/**
 * Product List Dispatcher
 * @class ProductDispatcher
 * @extends ProductDispatcher
 * @namespace Scandipwa/Store/Product/Dispatcher */
export class ProductDispatcher extends QueryDispatcher {
    __construct() {
        super.__construct('Product');
    }

    onSuccess(data, dispatch) {
        const { products: { items, content_blocks: { content_html } } } = data;
        /**
         * In case there are no items, or item count is
         * smaller then 0 => the product was not found.
         */
        if (!items || items.length <= 0) {
            dispatch(updateNoMatch(true));
            return;
        }

        const [product] = items;

        dispatch(updateProductDetails(product, content_html));
    }

    onError(_, dispatch) {
        dispatch(updateNoMatch(true));
    }

    prepareRequest(options) {
        return ProductListQuery.getQuery(options);
    }
}

export default new ProductDispatcher();
